import { Typography } from "@mui/material";
import { TEXT_SECONDARY } from "@/config/mui/colorPalette";
import { getReminderTimeLabel } from "../serviceFlow/settings/clientCommunication/selectReminderTime";

type ClientAffirmationLabelProps = {
  customClientAffirmation: string;
  lateCancellationHours: number;
  cancellationFeePolicyEnabled: boolean;
  noShowFeeValue: number;
  depositAmount: number;
  allowDeposits: boolean;
};

export default function ClientAffirmationLabel({
  customClientAffirmation,
  lateCancellationHours,
  cancellationFeePolicyEnabled,
  noShowFeeValue,
  depositAmount,
  allowDeposits,
}: ClientAffirmationLabelProps) {
  const hoursLabel = getReminderTimeLabel(lateCancellationHours);

  const getCheckboxLabel = () => {
    if (customClientAffirmation) {
      return customClientAffirmation;
    }
    if (cancellationFeePolicyEnabled && allowDeposits) {
      return `Rescheduling or canceling your appointment should be communicated within ${hoursLabel} of the appointment to prevent a $${noShowFeeValue} cancellation fees and/or forfeitures of your $${depositAmount} deposit. The deposit will be charged upon booking to be used towards the value of future appointments; the cancelation fee will only be charged if you cancel within ${hoursLabel} of the appointment.`;
    }
    if (cancellationFeePolicyEnabled) {
      return `Rescheduling or appointment cancellation should be communicated within ${hoursLabel} of the appointment to prevent a $${noShowFeeValue} cancellation fees. Your card details will be securely held in case of late cancellation and for future purchases. It will not be charged now.`;
    }
    if (allowDeposits) {
      return `Upon booking, your credit card will be charged $${depositAmount} for your deposit, to be used towards the value of your appointment.`;
    }
  };

  return (
    <Typography
      variant="labelDefault"
      sx={{
        color: TEXT_SECONDARY,
        mt: 1,
      }}
    >
      {getCheckboxLabel()}
    </Typography>
  );
}
